import { Component, input, output } from '@angular/core';

import type { KlDetailFilterChipRow, KlDetailFilterSavedRow } from './kl-detail-filter.models';

/**
 * Full legacy-style detail filter layout: toolbar + three columns.
 * Projects the left column via `[klDetailFilterLeft]`; middle and right columns are built-in (chips + saved designs).
 */
@Component({
  selector: 'kl-detail-filter',
  standalone: false,
  templateUrl: './kl-detail-filter.html',
  styleUrl: './kl-detail-filter.scss',
})
export class KlDetailFilterComponent {
  readonly loading = input(false);
  readonly alertShow = input(false);
  readonly alertMessage = input('');

  readonly middleTitleKey = input('filter_values');
  readonly rightTitleKey = input('saved_filters');
  readonly applyLabelKey = input('filter');
  readonly clearLabelKey = input('clear');
  readonly closeLabelKey = input('close');

  readonly showSaveAsPlaceholder = input(false);
  readonly saveAsPlaceholderLabelKey = input('save_new_design');

  readonly chipRows = input<readonly KlDetailFilterChipRow[]>([]);
  readonly savedRows = input<readonly KlDetailFilterSavedRow[]>([]);
  readonly selectedSavedId = input<number | string | null>(null);
  readonly designBusy = input(false);
  /** When true, disables “update active design” (e.g. no saved row selected). */
  readonly updateSavedDisabled = input(false);
  /** When false, hides the saved filters column (screens without saved filter designs). */
  readonly showSaved = input(true);

  readonly apply = output<void>();
  readonly clear = output<void>();
  readonly close = output<void>();
  readonly alertClose = output<void>();

  readonly removeChip = output<string>();
  readonly selectSaved = output<KlDetailFilterSavedRow>();
  readonly deleteSaved = output<KlDetailFilterSavedRow>();
  readonly saveNewDesign = output<void>();
  readonly updateActiveDesign = output<void>();

  onApply(): void {
    this.apply.emit();
  }

  onClear(): void {
    this.clear.emit();
  }

  onClose(): void {
    this.close.emit();
  }

  onAlertClose(): void {
    this.alertClose.emit();
  }
}
